import React from "react";
import { NavLink } from "react-router-dom";
// import BannerImage2 from '../../assets/images/banner-img2.jpg'
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import RecBanner from "../../assets/images/recruiting/rec-banner.png";
import TargetedTalent from "../../assets/images/recruiting/targeted-talent.svg";
import AutoCandNurturing from "../../assets/images/recruiting/automated-candidate-nurturing.svg";
import SeamlessInte from "../../assets/images/recruiting/seamlessInte.svg";
import CompreCanProf from "../../assets/images/recruiting/comprehensiveCandidateProfiles.svg";
import EffiInterSchedule from "../../assets/images/recruiting/effieientInterSche.svg";
import CollabAndComms from "../../assets/images/recruiting/colabAndComms.svg";
import FastHire from "../../assets/images/recruiting/fasterTimeHire.svg";
import QualityHires from "../../assets/images/recruiting/quality-hires.svg";
import ImproveTeamCollab from "../../assets/images/recruiting/impTeamCollab.svg";
import DataDrivenRec from "../../assets/images/recruiting/dataDrivenRecruitment.svg";
import Testimonials from "../../components/home/Testimonials";
import Cta from "../../components/cta/cta";

const HiringPage = () => {
  return (
    <>
      <div className="rec-main-wrapper">
        <section className="rec-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb10 text-color-131415">
                    Streamline Your Recruitment Process with BeyondLeadz
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    HR and Recruitment teams can utilize BeyondLeadz Data to
                    streamline the hiring process by accessing relevant
                    candidate profiles.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={RecBanner}
                    className="img-responsive position-relative"
                    alt=" Streamline Your Recruitment Process with BeyondLeadz"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="rec-three _border-bottom">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Why HR and Recruitment Teams Should Use BeyondLeadz
              </h2>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={TargetedTalent}
                      className="img-responsive position-relative"
                      alt="Targeted Talent Sourcing"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Targeted Talent Sourcing
                    </h3>
                    <p className="roboto-regular heading16px">
                      BeyondLeadz enables you to build and manage talent pools
                      based on specific skills, experience, and qualifications.
                      Use advanced search and filtering options to identify the
                      best candidates for your open positions.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={AutoCandNurturing}
                      className="img-responsive position-relative"
                      alt="Automated Candidate Nurturing"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Automated Candidate Nurturing
                    </h3>
                    <p className="roboto-regular heading16px">
                      Keep candidates engaged with automated follow-ups and
                      personalized communications. BeyondLeadz allows you to set
                      up workflows that nurture talent throughout the
                      recruitment process, ensuring that top candidates remain
                      interested and informed.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={SeamlessInte}
                      className="img-responsive position-relative"
                      alt="Seamless Integration with Job Portals"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Seamless Integration with Job Portals
                    </h3>
                    <p className="roboto-regular heading16px">
                      Integrate BeyondLeadz with popular job boards, LinkedIn,
                      and your company’s career page to capture candidate
                      information directly into your system. This ensures a
                      consistent flow of talent into your recruitment pipeline.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={CompreCanProf}
                      className="img-responsive position-relative"
                      alt="Comprehensive Candidate Profiles"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Comprehensive Candidate Profiles
                    </h3>
                    <p className="roboto-regular heading16px">
                      Enrich candidate data with additional information such as
                      previous job history, education, certifications, and more.
                      This helps you get a fuller understanding of each
                      candidate, allowing for better decision-making.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={EffiInterSchedule}
                      className="img-responsive position-relative"
                      alt="Efficient Interview Scheduling"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Efficient Interview Scheduling
                    </h3>
                    <p className="roboto-regular heading16px">
                      Streamline the interview scheduling process with automated
                      calendar integrations. BeyondLeadz allows candidates to
                      choose available slots that work best for them, reducing
                      back-and-forth communication and speeding up the
                      recruitment process.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={CollabAndComms}
                      className="img-responsive position-relative"
                      alt="Collaboration and Communication"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Collaboration and Communication
                    </h3>
                    <p className="roboto-regular heading16px">
                      BeyondLeadz makes it easy for HR teams to collaborate on
                      candidate evaluations, share notes, and track progress.
                      Keep everyone on the same page with real-time updates and
                      a centralized system for all recruitment activities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rec-four">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Benefits for HR and Recruitment Teams
              </h2>
              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": "repeat(2, 1fr)",
                  "--grid-gap": "24px",
                }}
              >
                <div className="common-white-box common-shadow">
                  <img
                    src={FastHire}
                    className="img-responsive"
                    alt="Faster Time-to-Hire"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Faster Time-to-Hire
                  </h3>
                  <p className="roboto-regular heading16px">
                    Automate repetitive tasks and streamline your recruitment
                    process to reduce the time it takes to move candidates from
                    application to offer.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={QualityHires}
                    className="img-responsive"
                    alt="Higher Quality Hires"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Higher Quality Hires
                  </h3>
                  <p className="roboto-regular heading16px">
                    Source and engage with candidates who best fit your job
                    requirements, improving the quality of your hires and
                    reducing turnover rates.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={ImproveTeamCollab}
                    className="img-responsive"
                    alt="Improved Team Collaboration"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Improved Team Collaboration
                  </h3>
                  <p className="roboto-regular heading16px">
                    Share information and collaborate with your team more
                    effectively, ensuring that every candidate is thoroughly
                    evaluated.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={DataDrivenRec}
                    className="img-responsive"
                    alt="Data-Driven Recruitment"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Data-Driven Recruitment
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use real-time analytics to track recruitment metrics, such
                    as source effectiveness, candidate conversion rates, and
                    time-to-hire, allowing you to optimize your strategies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>

      {/* <div className="sales-wrapper">
                <section className="sales-banner">
                    <div className="max-container">
                        <div className="padd-90">
                            <div className="grid-auto-fit align-items-center">
                                <div>
                                    <h1 className="heading39px roboto-bold mb10 text-color-131415">
                                        Find candidates with
                                        real-time verified
                                        personal emails
                                    </h1>
                                    <p className="heading16px roboto-regular mb30">Streamline candidate sourcing with our searchable database, powered by Linkedin. Identify candidates, and receive live details such as time in current role, open-to-work status, and more.</p>

                                    <ul className="btn-sec">
                                        <li>
                                            <NavLink to={"/signup"} className="common-btn-class main-btn-primary roboto-regular"> Subscribe Now</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={"/contact-us"} className="common-btn-class main-btn-primary roboto-regular">Contact us</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <img src={BannerImage2} className="img-responsive position-relative" alt="Double Your Qualified Leads" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="clients-row _border-bottom bck-color-fafafa">
                    <div className="max-container">
                        <h2 className="roboto-bold mb40 text-center heading24px">Trusted by 100,000+ recruiters at 50,000+ companies</h2>
                        <div className="grid-auto-fit align-items-center">
                            <div className="text-center">
                                <img src={TataImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={CanonImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={DellImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={PanasonicImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={BimtechImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={AirtelImage} alt="Clients" className="img-responsive" />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bck-color-fafafa">
                    <div className="max-container">
                        <div className="padd-90">
                            <div className="text-center mb40">
                                <h2 className="roboto-bold mb10 heading29px">Here’s how BeyondLeadz can help you</h2>

                                <p className="heading16px roboto-regular ">
                                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.  Lorem ipsum, dolor sit amet  <br /> consectetur adipisicing elit.
                                </p>

                            </div>

                            <div className="grid-auto-fit" style={{ '--grid-gap': gap24px }}>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Demand Gen Specialist</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Supply leads that convert</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-1-3.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Demand Gen Specialist</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Supply leads that convert</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Marketing Manager</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Know your audience’s needs</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-2-2.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Marketing Manager</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Know your audience’s needs</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Director of Marketing</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Strategize with data that delivers</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-3-2.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Director of Marketing</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Strategize with data that delivers</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                <section className="">
                    <div className="max-container">
                        <div className="padd-90">
                            <h2 className="roboto-bold mb10 heading29px mb40 text-center">"It’s like you read my mind!” - Your leads…probably.</h2>
                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">Meet your top prospects right
                                        when they need you</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>
                                </div>
                                <div>
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                            </div>

                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div className="block-order2">
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">The enriched get richer</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>

                                </div>
                            </div>

                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">Targeting the right audience
                                        has never been easier</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>
                                </div>
                                <div>
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <Subscribe />
            </div > */}
    </>
  );
};

export default HiringPage;
